/**
 * Check whether a subscriber giveaway is open and reveal its enter button if so.
 *
 * @param  {Element} el   An element hidden by a `subscriber-giveaway__enter-button--hidden` class
 * @return {Void}
 */

import { addClass, removeClass } from "../utilities";

export default function subscriberGiveawayEnterButton(el, props) {
  const enterButtonAnchor = el.querySelector("#enter-now");

  fetch(`/subscriber-giveaways/${props.slug}/status.json`, {
    method: "GET",
    credentials: "same-origin",
    headers: {
      accept: "application/json"
    }
  })
    .then(response => {
      return response.json();
    })
    .then(subscriberGiveawayStatus => {
      if (subscriberGiveawayStatus.status === "open") {
        enterButtonAnchor.href = props.new_entry_path;
        enterButtonAnchor.innerText = "Enter now";
      } else if (subscriberGiveawayStatus.status === "pending") {
        enterButtonAnchor.href = "#";
        enterButtonAnchor.innerText = "Giveaway not yet open";
        addClass(
          enterButtonAnchor,
          "subscriber-giveaway__enter-button--disabled"
        );
      } else {
        enterButtonAnchor.href = "#";
        enterButtonAnchor.innerText = "Giveaway closed";
        addClass(
          enterButtonAnchor,
          "subscriber-giveaway__enter-button--disabled"
        );
      }

      removeClass(el, "subscriber-giveaway__enter-button--hidden");
    })
    .catch(function() {
      return;
    });
}
